import { useContext } from 'react';

import AppContext, { AppContextValues } from './context';

const useAppData = (): AppContextValues => useContext(AppContext);

export default useAppData;
